(() => {
  // src/js/reservations.js
  function Reservations() {
    this.variant = null;
    function bindReservationForm(modal, productForm) {
      productForm.addEventListener("variant:change", (e) => {
        if (!e?.detail?.variant) return;
        window.currentSelectedVariant = e.detail.variant;
        const productDataInput = modal.querySelector('input[name="product_data"]');
        if (productDataInput) {
          productDataInput.value = JSON.stringify(e.detail.variant);
        }
        updateModalVariantInfo(modal, e.detail.variant);
      });
    }
    function updateModalVariantInfo(modal, variant) {
      const modalVariantInfo = modal.querySelector(".line-item");
      if (modalVariantInfo) {
        modalVariantInfo.querySelector(".h7").innerText = variant.name.split("-")[0];
        modalVariantInfo.querySelector(".line-item__media").removeAttribute("srcset");
        modalVariantInfo.querySelectorAll(".line-item-info__option span").forEach((option, index) => {
          option.innerText = variant.options[index];
        });
        modalVariantInfo.querySelector(".line-item__media").setAttribute("src", variant.featured_image?.src);
      }
    }
    function bindReservationButton(button, modal, productForm) {
      productForm.addEventListener("variant:change", (e) => {
        if (modal.getAttribute("data-variants").includes(e.detail.variant.id.toString())) {
          button.classList.remove("hidden");
        } else {
          button.classList.add("hidden");
        }
      });
    }
    function bindReservationSubmit(modal) {
      modal.querySelector('button[type="submit"]').addEventListener("click", (e) => {
        e.preventDefault();
        e.target.setAttribute("disabled", true);
        try {
          if (!window.azureIntegration || window.window.azureIntegration.reservationEndpoint == "") {
            throw "generic_network_error";
          }
          fetch(window.azureIntegration.reservationEndpoint, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Signature": window.azureIntegration.signature,
              "X-SignatureBody": window.azureIntegration.signatureBody
            },
            body: JSON.stringify(getReservationBody(modal))
          }).then((response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw "generic_network_error";
            }
          }).then((data) => {
            if (data.result == "OK") {
              displayBanner(modal, "success", "success");
            } else {
              data.messages.forEach((message) => {
                displayBanner(modal, message);
              });
            }
            e.target.removeAttribute("disabled");
          }).catch((error) => {
            e.target.removeAttribute("disabled");
            console.error(error);
            displayBanner(modal, error);
          });
        } catch (error) {
          e.target.removeAttribute("disabled");
          console.error(error);
          displayBanner(modal, error);
        }
      });
    }
    function getReservationBody(modal) {
      const subscribeToNewsletter = modal.querySelector('input[name="subscribe_newsletter"]:checked') ? true : false;
      const customer_email = modal.querySelector('input[name="contact[email]"]');
      const privacy_checkbox = modal.querySelector(
        'input[name="privacy_policy"]'
      );
      if (!customer_email || !customer_email.value) {
        throw "missing_customer_email";
      }
      if (!customer_email.checkValidity()) {
        throw "invalid_customer_email";
      }
      if (privacy_checkbox && !privacy_checkbox.checked) {
        throw "privacy_not_checked";
      }
      if (!window.currentSelectedVariant) {
        throw "missing_variant";
      }
      if (window.currentSelectedVariant.available) {
        throw "available_variant";
      }
      return {
        "customer_id": window?.currentCustomer || null,
        "customer_email": customer_email.value,
        "customer_email_subscription": subscribeToNewsletter,
        "sku": window.currentSelectedVariant.sku,
        "shop": window.themeVariables.settings.shopPermanentUrl,
        "product_link": location.href,
        "product_name": window.currentSelectedVariant.name,
        "language": window.themeVariables.settings.language,
        "market_id": window.themeVariables.settings.market_id,
        "market_handle": window.themeVariables.settings.market_handle,
        "market_country": window.themeVariables.settings.country,
        "request_type": "backinstock"
      };
    }
    function displayBanner(modal, error, type = "error") {
      if (window.azureIntegration.translations[error]) {
        const errorElement = document.createElement("div");
        errorElement.innerText = window.azureIntegration.translations[error];
        errorElement.classList.add("banner", "banner--" + type);
        modal.querySelector(".form").appendChild(errorElement);
        setTimeout(() => {
          errorElement.remove();
        }, window.azureIntegration.bannerTimeout);
      }
    }
    function init() {
      const reservationsOpener = document.querySelector(".button-reserve");
      const reservationsModal = document.querySelector(".modal-reservations");
      const masterForm = document.querySelector(".product-info__block-item .shopify-product-form");
      if (reservationsOpener && reservationsModal && masterForm) {
        bindReservationForm(reservationsModal, masterForm);
        bindReservationButton(reservationsOpener, reservationsModal, masterForm);
        bindReservationSubmit(reservationsModal, masterForm);
      }
    }
    init();
  }
  document.addEventListener("DOMContentLoaded", () => {
    Reservations();
  });
})();
